import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import PersonIcon from '@mui/icons-material/Person';
import Logout from '@mui/icons-material/Logout';

import { SUPER_ADMIN, ADMIN } from 'constants/roles';
import { routes } from 'services/router';
import { getRole, getUser, setSelectedMenuItemId } from 'services/localStorage';
import { useSignOut } from 'hooks/signOut';

import * as S from './styled';

export default function Profile() {
  const history = useHistory();
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const [, signOut] = useSignOut(dispatch);
  const role = getRole();
  const useProfile = getUser();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfile = () => {
    const url = routes.dashboardModule.editProfile;
    setSelectedMenuItemId(-1);
    history.push(url);
  };

  const handleSignOut = () => {
    signOut();
  };

  const getRoleLabel = data => {
    switch (data) {
      case SUPER_ADMIN:
        return t('header.adminTitle');
      case ADMIN:
        return t('header.adminLabTitle');
      default:
        return t('header.userTitle');
    }
  };

  return (
    <>
      <Tooltip title={t('header.profile')}>
        <S.ProfileButton onClick={handleClick} sx={{ ml: 2 }}>
          {useProfile.firstname}
          <PersonIcon fontSize="small" sx={{ ml: 1 }} />
        </S.ProfileButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <S.Name disabled>{`${useProfile.firstname} ${useProfile.lastname}`}</S.Name>
        <S.Title disabled>{getRoleLabel(role)}</S.Title>
        <Divider />
        <MenuItem onClick={handleProfile}>
          <ListItemIcon>
            <PersonIcon fontSize="small" />
          </ListItemIcon>
          {t('header.profile')}
        </MenuItem>
        <MenuItem onClick={handleSignOut}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          {t('header.signOut')}
        </MenuItem>
      </Menu>
    </>
  );
}
